/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, OnInit } from '@angular/core';
import { AuthentificationService } from '../../sharedServices/authentification.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signin-callback',
  templateUrl: './signin-callback.component.html'
})
export class SigninCallbackComponent implements OnInit {

  constructor(private readonly authentificationService: AuthentificationService, private readonly router: Router) { }

   ngOnInit() {
    this.authentificationService.completeLogin().then(() => {

      this.router.navigate(['app-search-fitting']);
    });
  }

}
